// Define commonly used constants
export const LS_ADMIN_USER_AUTH_TOKEN = '__pnm_admin_t';
export const LS_ADMIN_USER_NAME = '__pnm_admin_n';
export const LS_ADMIN_USER_EMAIL = '__pnm_admin_e';
export const LS_ADMIN_USER_ROLE = '__pnm_admin_r';

export const VALID_ADMIN_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  CHANNEL_OWNER: 'CHANNEL_OWNER',
  CONTENT_OWNER: 'CONTENT_OWNER',
};

export const VALID_CONTENT_OWNER_ROLES = {
  DISTRIBUTOR: 'DISTRIBUTOR',
  FILMMAKER: 'FILMMAKER',
  AGGREGATOR: 'AGGREGATOR',
};

export const STATUS_LABELS = {
  0: 'Inactive',
  1: 'Active',
  2: 'Deleted',
  5: 'Requested Delete',
  10: 'Trial Period',
  11: 'Pending Verification',
  12: 'Cancellation Applied',
  13: 'Cancelled',
  14: 'Expired',
};

export const MANUAL_STATUS_LABELS = {
  0: 'Manual Off',
  1: 'Manual On',
};

export const MIGRATION_STATUS_LABELS = {
  0: 'None',
  1: 'Imported',
  2: 'Login Attempted',
  3: 'Password Reset',
  4: 'Account Synced',
  5: 'Migrated',
};

export const BRD_STATUS_LABELS = {
  0: 'No',
  1: 'Yes',
};

export const STATUS_COLORS = {
  0: 'error',
  1: 'success',
  2: 'error',
  5: 'warning',
  10: 'info',
  11: 'warning',
  12: 'warning',
  13: 'error',
  14: 'error',
};

export const MIGRATION_STATUS_COLORS = {
  0: 'error',
  1: 'primary',
  2: 'primary',
  3: 'info',
  4: 'warning',
  5: 'success',
};

export const STATUS_ALL_VALUE = 99999;

export const ACTIONS = {
  CREATE: {
    value: 'create',
    label: 'Create New',
  },
  EDIT: {
    value: 'update',
    label: 'Edit',
  },
  VIEW: {
    value: 'view',
    label: 'View',
  },
  DELETE: {
    value: 'delete',
    label: 'Delete',
  },
  CHANGE_PASSWORD: {
    value: 'change_password',
    label: 'Change Password',
  },
  ASSIGN_CHANNELS: {
    value: 'assign_channels',
    label: 'Assign Channels',
  },
  COPY_CHANNEL: {
    value: 'duplicate_channel',
    label: 'Duplicate Channel',
  },
  CREATE_SUBSCRIPTION: {
    value: 'create_subscription',
    label: 'Create Subscription',
  },
  EDIT_SUBSCRIPTION: {
    value: 'edit_subscription',
    label: 'Edit Subscription',
  },
  VIEW_SUBSCRIPTION: {
    value: 'view_subscription',
    label: 'View Subscription',
  },
  SUBSCRIPTIONS_HISTORY: {
    value: 'subscriptions_history',
    label: 'Subscriptions History',
  },
  REMOVE_SUBSCRIPTION: {
    value: 'remove_subscription',
    label: 'Remove Subscription',
  },
  MANAGE_VIDEOS: {
    value: 'manage_videos',
    label: 'Manage Videos',
  },
  GENERATE_ROKU_FEED: {
    value: 'generate_roku_feed',
    label: 'Generate Roku Feed',
  },
  REGENERATE_CACHE: {
    value: 'regenerate_cache',
    label: 'Regenerate Cache',
  },
  MANAGE_EPISODES: {
    value: 'manage_episodes',
    label: 'Manage Episodes',
  },
  PLAY_VIDEO: {
    value: 'play_video',
    label: 'Play Video',
  },
  MANAGE_EDITS: {
    value: 'manage_edits',
    label: 'Manage Edits',
  },
  PREVIEW: {
    value: 'preview',
    label: 'Preview',
  },
  MANAGE_ORDER: {
    value: 'manage_order',
    label: 'Manage Order',
  },
  VIEW_SUBSCRIBERS: {
    value: 'view_subscribers',
    label: 'View Subscribers',
  },
  CANCEL_SUBSCRIPTION: {
    value: 'cancel_subscription',
    label: 'Cancel Subscription',
  },
  CHECK_STATUS: {
    value: 'check_status',
    label: 'Check Status',
  },
  CANCEL_JOB: {
    value: 'cancel_job',
    label: 'Cancel Job',
  },
  PUSH_TO_CMS: {
    value: 'push_to_cms',
    label: 'Push to CMS',
  },
  RETRY: {
    value: 'retry',
    label: 'Retry',
  },
  MAKE_ACTIVE: {
    value: 'make_active',
    label: 'Make Active',
  },
  PROCESS_AGAIN: {
    value: 'process_again',
    label: 'Process Again',
  },
  REPROCESS_VIDEO: {
    value: 'reprocess_video',
    label: 'Reprocess Video',
  },
  REPROCESS_TRAILER: {
    value: 'reprocess_trailer',
    label: 'Reprocess Trailer',
  },
  COPY_URL: {
    value: 'copy_url',
    label: 'Copy URL',
  },
};

export const APP_TYPES = {
  AVOD_TYPE: 'AVOD Only',
  SVOD_TYPE: 'SVOD Only',
  TVOD_TYPE: 'TVOD Only',
  AVOD_SVOD_TYPE: 'AVOD & SVOD',
  AVOD_TVOD_TYPE: 'AVOD & TVOD',
  SVOD_TVOD_TYPE: 'SVOD & TVOD',
  AVOD_SVOD_TVOD_TYPE: 'AVOD & SVOD & TVOD',
};

export const IAP_SETTINGS = {
  ROKU_BB: 'Bach Entertainment (BadBen)',
  ROKU_POV: 'POV Horror LLC',
  ROKU_WICK_CON: 'PlayNowMedia LLC',
  ROKU_HB: 'Hexabrain',
  ROKU_HIGHSPOTS: 'HighSpots TV',
  FIRETV_BB: 'Bach Entertainment (BadBen)',
  FIRETV_POV: 'POV Horror LLC',
  FIRETV_PNM: 'PlayNowMedia LLC',
  FIRETV_HB: 'Hexabrain',
  FIRETV_HIGHSPOTS: 'HighSpots TV',
  ANDROID_THUNDER: 'Thunder Road Inc',
  ANDROID_PNM: 'PlayNowMedia LLC',
  ANDROID_HB: 'Hexabrain',
  APPLE_THUNDER: 'Thunder Road Inc',
  APPLE_PNM: 'PlayNowMedia LLC',
  APPLE_HB: 'Hexabrain',
  APPLE_HIGHSPOTS: 'HighSpots TV',
  WEB_BB: 'Stripe (BadBen)',
  WEB_BB_TEST: 'Stripe (BadBen) [Test]',
  WEB_POV: 'Stripe (POV Horror LLC)',
  WEB_POV_TEST: 'Stripe (POV Horror LLC) [Test]',
  WEB_HB_TEST: 'Stripe (Hexabrain) [Test]',
  SAMSUNG_YES: 'Yes',
  SAMSUNG_NO: 'NO',
};

export const RULESET_CONDITION = {
  AND: 'AND',
  OR: 'OR',
};

export const PLAYLIST_LEVEL = {
  1: '1-Level playlist',
  2: '2-Level playlist',
};

export const VIDEO_ORDER_FIELDS = {
  title_name_only: 'Title',
  video_type: 'Video Type',
  description: 'Description',
  description_status: 'Description Status',
  duration_minutes: 'Duration',
  year: 'Year',
  decade: 'Decade',
  country: 'Country',
  region: 'Region',
  cast: 'Cast',
  imdb_id: 'IMDB ID',
  UUID: 'UUID',
  date_creation: 'Date Creation',
  series__title: 'Series',
  season: 'Season',
  episode_num: 'Episode #',
  categories: 'Genres',
  plot_keywords: 'Keywords',
  collections__name: 'Collections',
  trashy: 'Trashy',
  good_bad: 'Good/Bad',
  pnm_exclusives: 'Exclusives',
  five_star_rating: '5 Star rating',
  offline: 'Offline',
  offline_reason: 'Offline Reason',
  mpaa_rating: 'MPAA Rating',
  restricted_content: 'Restricted Content',
  restricted_content_reason: 'Restricted Content Reason',
  restricted_content_source: 'Restricted Content Source',
  exclude_from_db: 'Exclude From DB',
  date_license_expiration: 'Date License Expiration',
  ad_timing_status: 'Ad timing status',
  genre_status: 'Genre Status',
  duplicate_imdb: 'Duplicate IMDB Check',
  quality_video: 'Video URL check',
  quality_poster_16x9: 'Poster URL check',
  quality_trailer: 'Trailer URL Check',
  video_status: 'Video Status',
  video_status_reason: 'Video Status Reason',
  video_status_reason_details: 'Video Status Details',
  trailer_status: 'Trailer Status',
  trailer_status_reason: 'Trailer Reason',
  tvod: 'TVOD Street Date',
  tvod_enabled: 'TVOD License',
  svod_enabled: 'SVOD License',
  tvod_iap: 'TVOD Price',
  svod: 'SVOD Street Date',
  avod: 'AVOD Street Date',
  avod_validated: 'AVOD License',
  avod_watched: 'AVOD Minutes Watched',
  avod_watched_7: 'AVOD Minutes Watched (week)',
  svod_watched: 'SVOD Minutes Watched',
  ad_timing: 'Ad Timing',
  ad_timing_detected: 'Auto-detected ad times',
  distributor_sku: 'Distributor SKU',
  distributor__Type: 'Distributor Type',
  distributor__name: 'Distributor Name',
  distributor__royality: 'Royalty',
  public_domain: 'Public Domain',
  custom_royality: 'Custom Royality',
  schedule_priority: 'Priority Schedule',
  geofencing_allow: 'GeoFencing Allow',
  geofencing_deny: 'GeoFencing Deny',
  trailer_url: 'Trailer URL',
  video_url: 'Video URL',
  poster_16x9_url: 'Poster 16x9',
  poster_16x9_status: 'Poster 16x9 Status',
  subtitle_en_url: 'Subtitle-EN URL',
  mm_notes: 'MM Notes',
  ms_notes: 'MS Notes',
  imdb_duration_minutes: 'IMDB Duration',
  imdb_language: 'IMDB Language',
  imdb_year: 'IMDB Year',
  imdb_plot_keywords: 'IMDB Keywords',
  imdb_directors: 'IMDB Directors',
  imdb_writers: 'IMDB Writers',
  imdb_cast: 'IMDB Cast',
  imdb_country: 'IMDB Country',
  imdb_description: 'IMDB Description',
  random_rank: 'Random Rank',
};

export const VIDEO_TYPES = {
  FE: 'Films',
  EP: 'Episode',
};

export const VIDEO_SOURCES = {
  NONE: '',
  FILE: 'File',
  YOUTUBE: 'YouTube',
};

export const VIDEO_RESOLUTION = {
  480: '480p',
  720: '720p',
  1080: '1080p',
  UK: 'Unknown',
};

export const TRASHY = {
  YES: 'Yes',
  NO: 'No',
  PD: 'Not Checked',
};

export const GOOD_BAD = {
  LF: 'Live Featured',
  FF: 'Future Featured',
  PF: 'Past Featured',
  G: 'Good',
  GB: 'Good-Bad',
  B: 'Bad',
  ND: 'No Data',
  NA: 'N/A',
};

export const IMDB_RANKING = {
  L4: '[<4]',
  45: '[4 to 4.9]',
  56: '[5 to 5.9]',
  67: '[6 to 6.9]',
  78: '[7 to 7.9]',
  89: '[8 to 8.9]',
  A9: '[>= 9]',
  NA: 'N/A',
};

export const MPAA_RATING = {
  G: 'General Audiences',
  PG: 'Parental Guidance Suggested',
  'PG-13': 'Parents Strongly Cautioned',
  R: 'Restricted',
  'NC-17': 'NC-17',
  NR: 'Not Rated',
};

export const RESTRICTED_CONTENT = {
  YES: 'Yes',
  NO: 'No',
  NC: 'Not Checked',
};

export const RESTRICTED_CONTENT_REASON = {
  ND: 'Nudity',
  EX: 'Extreme',
  LG: 'Language',
  GO: 'Gore',
  DR: 'Drug Use',
  PR: 'Remove From DB (Porn)',
  AD: 'Adult Content',
  NA: 'Not Assigned',
};

export const EXCLUDE_FROM_DB_REASON = {
  PR: 'Pornography',
  EX: 'Extreme',
  VO: 'Violence',
  OB: 'Objectionable',
  CN: 'Content',
};

export const AD_TIMING_STATUS = {
  NC: 'Not Checked',
  GD: 'Good',
  FI: 'Fixed Intervals',
  NN: 'No Ad Timing Needed',
};

export const GENRE_STATUS = {
  NC: 'Not Checked',
  GD: 'Good',
  NW: 'Needs Work',
};

export const QUALITY_MAX_RESOLUTION = {
  PS: 'Pass',
  OE: 'Over Encoded',
  NC: 'Not Checked',
};

export const VIDEO_STATUS = {
  NC: 'Not Checked',
  GD: 'Good',
  NI: 'Non-critical Issue',
};

export const VIDEO_STATUS_REASON = {
  NC: 'Not Checked',
  MS: 'Missing',
  BF: 'Bad File',
  WM: 'Wrong Movie',
  WE: 'Watermarked',
  PQ: 'Poor Video Quality',
  AN: 'Audio Not Synced',
  AM: 'Audio Dialog Missing',
  AI: 'Audio in one channel',
  AD: 'Audio Drops/Missing',
};

export const TRAILER_STATUS = {
  NC: 'Not Checked',
  GD: 'Good',
  NI: 'Missing',
  RM: 'Remove',
};

export const TRAILER_STATUS_REASON = {
  NC: 'Not Checked',
  RC: 'Restricted Content',
  WM: 'Wrong Movie',
  WE: 'Watermarked',
  PQ: 'Poor Quality',
  WL: 'Wrong Language',
  WF: 'Wrong Film',
};

export const TVOD_PRICE = {
  1: '0.99$',
  2: '1.99$',
  3: '2.99$',
  4: '3.99$',
  5: '4.99$',
  6: '5.99$',
  7: '6.99$',
  8: '7.99$',
  9: '8.99$',
  10: '9.99$',
};

export const QUALITY_CHECK = {
  PS: 'Pass',
  FA: 'Fail',
  NC: 'Not Checked',
};

export const QUALITY_CHECK_COLORS = {
  PS: 'success',
  FA: 'error',
  NC: 'warning',
};

export const REGIONS = [
  {
    value: 'NA',
    label: 'North America',
  },
  {
    value: 'SA',
    label: 'South America',
  },
  {
    value: 'EU',
    label: 'Europe',
  },
  {
    value: 'AS',
    label: 'Asia',
  },
  {
    value: 'AU',
    label: 'Australia',
  },
  {
    value: 'AF',
    label: 'Africa',
  },
  {
    value: 'OC',
    label: 'Oceania',
  },
  {
    value: 'AN',
    label: 'Antarctica',
  },
  {
    value: 'UK',
    label: 'Unknown',
  },
];

export const COUNTRIES = [
  { label: 'Rwanda', value: 'RW', regionCode: 'AF' },
  { label: 'Somalia', value: 'SO', regionCode: 'AF' },
  { label: 'Yemen', value: 'YE', regionCode: 'AS' },
  { label: 'Iraq', value: 'IQ', regionCode: 'AS' },
  { label: 'Saudi Arabia', value: 'SA', regionCode: 'AS' },
  { label: 'Iran', value: 'IR', regionCode: 'AS' },
  { label: 'Cyprus', value: 'CY', regionCode: 'EU' },
  { label: 'Tanzania', value: 'TZ', regionCode: 'AF' },
  { label: 'Syria', value: 'SY', regionCode: 'AS' },
  { label: 'Armenia', value: 'AM', regionCode: 'AS' },
  { label: 'Kenya', value: 'KE', regionCode: 'AF' },
  { label: 'DR Congo', value: 'CD', regionCode: 'AF' },
  { label: 'Djibouti', value: 'DJ', regionCode: 'AF' },
  { label: 'Uganda', value: 'UG', regionCode: 'AF' },
  { label: 'Central African Republic', value: 'CF', regionCode: 'AF' },
  { label: 'Seychelles', value: 'SC', regionCode: 'AF' },
  { label: 'Jordan', value: 'JO', regionCode: 'AS' },
  { label: 'Lebanon', value: 'LB', regionCode: 'AS' },
  { label: 'Kuwait', value: 'KW', regionCode: 'AS' },
  { label: 'Oman', value: 'OM', regionCode: 'AS' },
  { label: 'Qatar', value: 'QA', regionCode: 'AS' },
  { label: 'Bahrain', value: 'BH', regionCode: 'AS' },
  { label: 'United Arab Emirates', value: 'AE', regionCode: 'AS' },
  { label: 'Israel', value: 'IL', regionCode: 'AS' },
  { label: 'Turkey', value: 'TR', regionCode: 'AS' },
  { label: 'Ethiopia', value: 'ET', regionCode: 'AF' },
  { label: 'Eritrea', value: 'ER', regionCode: 'AF' },
  { label: 'Egypt', value: 'EG', regionCode: 'AF' },
  { label: 'Sudan', value: 'SD', regionCode: 'AF' },
  { label: 'Greece', value: 'GR', regionCode: 'EU' },
  { label: 'Burundi', value: 'BI', regionCode: 'AF' },
  { label: 'Estonia', value: 'EE', regionCode: 'EU' },
  { label: 'Latvia', value: 'LV', regionCode: 'EU' },
  { label: 'Azerbaijan', value: 'AZ', regionCode: 'AS' },
  { label: 'Lithuania', value: 'LT', regionCode: 'EU' },
  { label: 'Svalbard and Jan Mayen', value: 'SJ', regionCode: 'EU' },
  { label: 'Georgia', value: 'GE', regionCode: 'AS' },
  { label: 'Moldova', value: 'MD', regionCode: 'EU' },
  { label: 'Belarus', value: 'BY', regionCode: 'EU' },
  { label: 'Finland', value: 'FI', regionCode: 'EU' },
  { label: 'Åland', value: 'AX', regionCode: 'EU' },
  { label: 'Ukraine', value: 'UA', regionCode: 'EU' },
  { label: 'North Macedonia', value: 'MK', regionCode: 'EU' },
  { label: 'Hungary', value: 'HU', regionCode: 'EU' },
  { label: 'Bulgaria', value: 'BG', regionCode: 'EU' },
  { label: 'Albania', value: 'AL', regionCode: 'EU' },
  { label: 'Poland', value: 'PL', regionCode: 'EU' },
  { label: 'Romania', value: 'RO', regionCode: 'EU' },
  { label: 'Zimbabwe', value: 'ZW', regionCode: 'AF' },
  { label: 'Zambia', value: 'ZM', regionCode: 'AF' },
  { label: 'Comoros', value: 'KM', regionCode: 'AF' },
  { label: 'Malawi', value: 'MW', regionCode: 'AF' },
  { label: 'Lesotho', value: 'LS', regionCode: 'AF' },
  { label: 'Botswana', value: 'BW', regionCode: 'AF' },
  { label: 'Mauritius', value: 'MU', regionCode: 'AF' },
  { label: 'Eswatini', value: 'SZ', regionCode: 'AF' },
  { label: 'Réunion', value: 'RE', regionCode: 'EU' },
  { label: 'South Africa', value: 'ZA', regionCode: 'AF' },
  { label: 'Mayotte', value: 'YT', regionCode: 'AF' },
  { label: 'Mozambique', value: 'MZ', regionCode: 'AF' },
  { label: 'Madagascar', value: 'MG', regionCode: 'AF' },
  { label: 'Afghanistan', value: 'AF', regionCode: 'AS' },
  { label: 'Pakistan', value: 'PK', regionCode: 'AS' },
  { label: 'Bangladesh', value: 'BD', regionCode: 'AS' },
  { label: 'Turkmenistan', value: 'TM', regionCode: 'AS' },
  { label: 'Tajikistan', value: 'TJ', regionCode: 'AS' },
  { label: 'Sri Lanka', value: 'LK', regionCode: 'AS' },
  { label: 'Bhutan', value: 'BT', regionCode: 'AS' },
  { label: 'India', value: 'IN', regionCode: 'AS' },
  { label: 'Maldives', value: 'MV', regionCode: 'AS' },
  { label: 'British Indian Ocean Territory', value: 'IO', regionCode: 'AS' },
  { label: 'Nepal', value: 'NP', regionCode: 'AS' },
  { label: 'Myanmar', value: 'MM', regionCode: 'AS' },
  { label: 'Uzbekistan', value: 'UZ', regionCode: 'AS' },
  { label: 'Kazakhstan', value: 'KZ', regionCode: 'AS' },
  { label: 'Kyrgyzstan', value: 'KG', regionCode: 'AS' },
  { label: 'French Southern Territories', value: 'TF', regionCode: 'AU' },
  { label: 'Heard Island and McDonald Islands', value: 'HM', regionCode: 'AU' },
  { label: 'Cocos [Keeling] Islands', value: 'CC', regionCode: 'AU' },
  { label: 'Palau', value: 'PW', regionCode: 'AU' },
  { label: 'Vietnam', value: 'VN', regionCode: 'AS' },
  { label: 'Thailand', value: 'TH', regionCode: 'AS' },
  { label: 'Indonesia', value: 'ID', regionCode: 'AS' },
  { label: 'Laos', value: 'LA', regionCode: 'AS' },
  { label: 'Taiwan', value: 'TW', regionCode: 'AS' },
  { label: 'Philippines', value: 'PH', regionCode: 'AS' },
  { label: 'Malaysia', value: 'MY', regionCode: 'AS' },
  { label: 'China', value: 'CN', regionCode: 'AS' },
  { label: 'Hong Kong', value: 'HK', regionCode: 'AS' },
  { label: 'Brunei', value: 'BN', regionCode: 'AS' },
  { label: 'Macao', value: 'MO', regionCode: 'AS' },
  { label: 'Cambodia', value: 'KH', regionCode: 'AS' },
  { label: 'South Korea', value: 'KR', regionCode: 'AS' },
  { label: 'Japan', value: 'JP', regionCode: 'AS' },
  { label: 'North Korea', value: 'KP', regionCode: 'AS' },
  { label: 'Singapore', value: 'SG', regionCode: 'AS' },
  { label: 'Cook Islands', value: 'CK', regionCode: 'AU' },
  { label: 'East Timor', value: 'TL', regionCode: 'AS' },
  { label: 'Russia', value: 'RU', regionCode: 'AS' },
  { label: 'Mongolia', value: 'MN', regionCode: 'AS' },
  { label: 'Australia', value: 'AU', regionCode: 'AU' },
  { label: 'Christmas Island', value: 'CX', regionCode: 'AU' },
  { label: 'Marshall Islands', value: 'MH', regionCode: 'AU' },
  { label: 'Federated States of Micronesia', value: 'FM', regionCode: 'AU' },
  { label: 'Papua New Guinea', value: 'PG', regionCode: 'AU' },
  { label: 'Solomon Islands', value: 'SB', regionCode: 'AU' },
  { label: 'Tuvalu', value: 'TV', regionCode: 'AU' },
  { label: 'Nauru', value: 'NR', regionCode: 'AU' },
  { label: 'Vanuatu', value: 'VU', regionCode: 'AU' },
  { label: 'New Caledonia', value: 'NC', regionCode: 'AU' },
  { label: 'Norfolk Island', value: 'NF', regionCode: 'AU' },
  { label: 'New Zealand', value: 'NZ', regionCode: 'OC' },
  { label: 'Fiji', value: 'FJ', regionCode: 'AU' },
  { label: 'Libya', value: 'LY', regionCode: 'AF' },
  { label: 'Cameroon', value: 'CM', regionCode: 'AF' },
  { label: 'Senegal', value: 'SN', regionCode: 'AF' },
  { label: 'Congo Republic', value: 'CG', regionCode: 'AF' },
  { label: 'Portugal', value: 'PT', regionCode: 'EU' },
  { label: 'Liberia', value: 'LR', regionCode: 'AF' },
  { label: 'Ivory Coast', value: 'CI', regionCode: 'AF' },
  { label: 'Ghana', value: 'GH', regionCode: 'AF' },
  { label: 'Equatorial Guinea', value: 'GQ', regionCode: 'AF' },
  { label: 'Nigeria', value: 'NG', regionCode: 'AF' },
  { label: 'Burkina Faso', value: 'BF', regionCode: 'AF' },
  { label: 'Togo', value: 'TG', regionCode: 'AF' },
  { label: 'Guinea-Bissau', value: 'GW', regionCode: 'AF' },
  { label: 'Mauritania', value: 'MR', regionCode: 'AF' },
  { label: 'Benin', value: 'BJ', regionCode: 'AF' },
  { label: 'Gabon', value: 'GA', regionCode: 'AF' },
  { label: 'Sierra Leone', value: 'SL', regionCode: 'AF' },
  { label: 'São Tomé and Príncipe', value: 'ST', regionCode: 'AF' },
  { label: 'Gibraltar', value: 'GI', regionCode: 'EU' },
  { label: 'Gambia', value: 'GM', regionCode: 'AF' },
  { label: 'Guinea', value: 'GN', regionCode: 'AF' },
  { label: 'Chad', value: 'TD', regionCode: 'AF' },
  { label: 'Niger', value: 'NE', regionCode: 'AF' },
  { label: 'Mali', value: 'ML', regionCode: 'AF' },
  { label: 'Western Sahara', value: 'EH', regionCode: 'AF' },
  { label: 'Tunisia', value: 'TN', regionCode: 'AF' },
  { label: 'Spain', value: 'ES', regionCode: 'EU' },
  { label: 'Morocco', value: 'MA', regionCode: 'AF' },
  { label: 'Malta', value: 'MT', regionCode: 'EU' },
  { label: 'Algeria', value: 'DZ', regionCode: 'AF' },
  { label: 'Faroe Islands', value: 'FO', regionCode: 'EU' },
  { label: 'Denmark', value: 'DK', regionCode: 'EU' },
  { label: 'Iceland', value: 'IS', regionCode: 'EU' },
  { label: 'United Kingdom', value: 'GB', regionCode: 'EU' },
  { label: 'Switzerland', value: 'CH', regionCode: 'EU' },
  { label: 'Sweden', value: 'SE', regionCode: 'EU' },
  { label: 'Netherlands', value: 'NL', regionCode: 'EU' },
  { label: 'Austria', value: 'AT', regionCode: 'EU' },
  { label: 'Belgium', value: 'BE', regionCode: 'EU' },
  { label: 'Germany', value: 'DE', regionCode: 'EU' },
  { label: 'Luxembourg', value: 'LU', regionCode: 'EU' },
  { label: 'Ireland', value: 'IE', regionCode: 'EU' },
  { label: 'Principality of Monaco', value: 'MC', regionCode: 'EU' },
  { label: 'France', value: 'FR', regionCode: 'EU' },
  { label: 'Andorra', value: 'AD', regionCode: 'EU' },
  { label: 'Liechtenstein', value: 'LI', regionCode: 'EU' },
  { label: 'Jersey', value: 'JE', regionCode: 'EU' },
  { label: 'Isle of Man', value: 'IM', regionCode: 'EU' },
  { label: 'Guernsey', value: 'GG', regionCode: 'EU' },
  { label: 'Slovakia', value: 'SK', regionCode: 'EU' },
  { label: 'Czechia', value: 'CZ', regionCode: 'EU' },
  { label: 'Norway', value: 'NO', regionCode: 'EU' },
  { label: 'Vatican City', value: 'VA', regionCode: 'EU' },
  { label: 'San Marino', value: 'SM', regionCode: 'EU' },
  { label: 'Italy', value: 'IT', regionCode: 'EU' },
  { label: 'Slovenia', value: 'SI', regionCode: 'EU' },
  { label: 'Montenegro', value: 'ME', regionCode: 'EU' },
  { label: 'Croatia', value: 'HR', regionCode: 'EU' },
  { label: 'Bosnia and Herzegovina', value: 'BA', regionCode: 'EU' },
  { label: 'Angola', value: 'AO', regionCode: 'AF' },
  { label: 'Namibia', value: 'NA', regionCode: 'AF' },
  { label: 'Saint Helena', value: 'SH', regionCode: 'AF' },
  { label: 'Bouvet Island', value: 'BV', regionCode: 'AF' },
  { label: 'Barbados', value: 'BB', regionCode: 'SA' },
  { label: 'Cabo Verde', value: 'CV', regionCode: 'AF' },
  { label: 'Guyana', value: 'GY', regionCode: 'SA' },
  { label: 'French Guiana', value: 'GF', regionCode: 'SA' },
  { label: 'Suriname', value: 'SR', regionCode: 'SA' },
  { label: 'Saint Pierre and Miquelon', value: 'PM', regionCode: 'NA' },
  { label: 'Greenland', value: 'GL', regionCode: 'NA' },
  { label: 'Paraguay', value: 'PY', regionCode: 'SA' },
  { label: 'Uruguay', value: 'UY', regionCode: 'SA' },
  { label: 'Brazil', value: 'BR', regionCode: 'SA' },
  { label: 'Falkland Islands', value: 'FK', regionCode: 'SA' },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'GS',
    regionCode: 'AN',
  },
  { label: 'Jamaica', value: 'JM', regionCode: 'SA' },
  { label: 'Dominican Republic', value: 'DO', regionCode: 'SA' },
  { label: 'Cuba', value: 'CU', regionCode: 'SA' },
  { label: 'Martinique', value: 'MQ', regionCode: 'SA' },
  { label: 'Bahamas', value: 'BS', regionCode: 'SA' },
  { label: 'Bermuda', value: 'BM', regionCode: 'SA' },
  { label: 'Anguilla', value: 'AI', regionCode: 'SA' },
  { label: 'Trinidad and Tobago', value: 'TT', regionCode: 'SA' },
  { label: 'St Kitts and Nevis', value: 'KN', regionCode: 'SA' },
  { label: 'Dominica', value: 'DM', regionCode: 'SA' },
  { label: 'Antigua and Barbuda', value: 'AG', regionCode: 'SA' },
  { label: 'Saint Lucia', value: 'LC', regionCode: 'SA' },
  { label: 'Turks and Caicos Islands', value: 'TC', regionCode: 'SA' },
  { label: 'Aruba', value: 'AW', regionCode: 'SA' },
  { label: 'British Virgin Islands', value: 'VG', regionCode: 'SA' },
  { label: 'Saint Vincent and the Grenadines', value: 'VC', regionCode: 'SA' },
  { label: 'Montserrat', value: 'MS', regionCode: 'SA' },
  { label: 'Saint Martin', value: 'MF', regionCode: 'NA' },
  { label: 'Saint Barthélemy', value: 'BL', regionCode: 'NA' },
  { label: 'Guadeloupe', value: 'GP', regionCode: 'SA' },
  { label: 'Grenada', value: 'GD', regionCode: 'SA' },
  { label: 'Cayman Islands', value: 'KY', regionCode: 'SA' },
  { label: 'Belize', value: 'BZ', regionCode: 'SA' },
  { label: 'El Salvador', value: 'SV', regionCode: 'SA' },
  { label: 'Guatemala', value: 'GT', regionCode: 'SA' },
  { label: 'Honduras', value: 'HN', regionCode: 'SA' },
  { label: 'Nicaragua', value: 'NI', regionCode: 'SA' },
  { label: 'Costa Rica', value: 'CR', regionCode: 'SA' },
  { label: 'Venezuela', value: 'VE', regionCode: 'SA' },
  { label: 'Ecuador', value: 'EC', regionCode: 'SA' },
  { label: 'Colombia', value: 'CO', regionCode: 'SA' },
  { label: 'Panama', value: 'PA', regionCode: 'SA' },
  { label: 'Haiti', value: 'HT', regionCode: 'SA' },
  { label: 'Argentina', value: 'AR', regionCode: 'SA' },
  { label: 'Chile', value: 'CL', regionCode: 'SA' },
  { label: 'Bolivia', value: 'BO', regionCode: 'SA' },
  { label: 'Peru', value: 'PE', regionCode: 'SA' },
  { label: 'Mexico', value: 'MX', regionCode: 'SA' },
  { label: 'French Polynesia', value: 'PF', regionCode: 'AU' },
  { label: 'Pitcairn Islands', value: 'PN', regionCode: 'AU' },
  { label: 'Kiribati', value: 'KI', regionCode: 'AU' },
  { label: 'Tokelau', value: 'TK', regionCode: 'AU' },
  { label: 'Tonga', value: 'TO', regionCode: 'AU' },
  { label: 'Wallis and Futuna', value: 'WF', regionCode: 'AU' },
  { label: 'Samoa', value: 'WS', regionCode: 'AU' },
  { label: 'Niue', value: 'NU', regionCode: 'AU' },
  { label: 'Northern Mariana Islands', value: 'MP', regionCode: 'AU' },
  { label: 'Guam', value: 'GU', regionCode: 'AU' },
  { label: 'Puerto Rico', value: 'PR', regionCode: 'SA' },
  { label: 'U.S. Virgin Islands', value: 'VI', regionCode: 'SA' },
  { label: 'U.S. Minor Outlying Islands', value: 'UM', regionCode: 'NA' },
  { label: 'American Samoa', value: 'AS', regionCode: 'AU' },
  { label: 'Canada', value: 'CA', regionCode: 'NA' },
  { label: 'United States', value: 'US', regionCode: 'NA' },
  { label: 'Palestine', value: 'PS', regionCode: 'AS' },
  { label: 'Serbia', value: 'RS', regionCode: 'EU' },
  { label: 'Antarctica', value: 'AQ', regionCode: 'AN' },
  { label: 'Sint Maarten', value: 'SX', regionCode: 'NA' },
  { label: 'Curaçao', value: 'CW', regionCode: 'SA' },
  { label: 'Bonaire, Sint Eustatius, and Saba', value: 'BQ', regionCode: 'SA' },
  { label: 'South Sudan', value: 'SS', regionCode: 'AF' },
  { label: 'Unknown', value: 'UN', regionCode: '' },
];

export const FILTER_CONDITION_TYPE = {
  CONTAINS: 'Contains',
  DOES_NOT_CONTAIN: 'Does not contain',
  EQUALS_TO: 'Equals to',
  BLANK: 'Blank',
  NOT_BLANK: 'Not Blank',
};

export const FILTER_SELECT_FIELD_CONDITION = {
  EQUALS_TO: 'Equals to',
  NOT_EQUALS_TO: 'Not Equals to',
};

export const DECADES = {
  '1910s': '1910s',
  '1920s': '1920s',
  '1930s': '1930s',
  '1940s': '1940s',
  '1950s': '1950s',
  '1960s': '1960s',
  '1970s': '1970s',
  '1980s': '1980s',
  '1990s': '1990s',
  '2000s': '2000s',
  '2010s': '2010s',
  '2020s': '2020s',
  '2030s': '2030s',
};

export const BOOLEAN = {
  YES: 'Yes',
  NO: 'No',
};

export const CHANNEL_SCHEDULE_VIEW_TYPE = {
  MOVIES: 'Movies',
  COLLECTIONS: 'Collections',
  SERIES: 'Series',
  APP_VIEW: 'App View',
};

export const URL_CHECK = {
  PS: 'Pass',
  FA: 'Fail',
  NC: 'Not Checked',
};

export const URL_CHECK_COLORS = {
  PS: 'success',
  FA: 'error',
  NC: 'warning',
};

export const WATCH_TIME_TYPE = [
  {
    label: 'Seconds',
    value: 'SECONDS',
  },
  {
    label: 'Minutes',
    value: 'MINUTES',
  },
  {
    label: 'Hours',
    value: 'HOURS',
  },
];

export const ROKU_FEED_STATUS_LABELS = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  NOT_GENERATED: 'Not Generated',
};

export const ROKU_FEED_STATUS_COLORS = {
  PENDING: 'warning',
  PROCESSING: 'warning',
  COMPLETED: 'success',
  FAILED: 'error',
  NOT_GENERATED: 'info',
};

export const PUBLIC_DOMAIN = {
  YES: 'Yes',
  LK: 'Likely',
  PR: 'Probably',
  MY: 'Maybe',
  UV: 'Unverified',
  NO: 'No',
  PD: 'Not Checked',
};

export const POSTER_16X9_STATUS = {
  GD: 'Good',
  MS: 'Missing',
  NC: 'Not Checked',
  OC: 'Offensive Content',
  PQ: 'Poor Quality',
  WS: 'Wrong Size',
};

export const ALWAYS_PUBLISHED = {
  NO: 'No',
  MV: 'Marketing Video (1900)',
  PD: 'Public Domain (1977)',
  PA: 'Public Domain Always On (1988)',
  HQ: 'High Quality Always On (1999)',
  DR: 'Distributor Request',
};

export const VIDEOJS_OPTIONS = {
  controls: true,
  preload: 'auto',
  responsive: true,
  controlBar: {
    pictureInPictureToggle: false,
  },
  sources: [
    {
      src: '',
    },
  ],
};

export const VIDEO_EDIT_FIELDS = {
  description: 'Description',
  poster_16x9_status: 'Poster 16x9 Status',
  avod_validated: 'Avod License',
  restricted_content: 'Restricted Content',
  avod: 'Avod',
  video_type: 'Video Type',
  season: 'Season',
  episode_num: 'Episode Num',
  date_license_expiration: 'Date License Expiration',
  distributor_sku: 'Distributor Sku',
  categories: 'Categories',
  ms_notes: 'Ms Notes',
  offline: 'Offline',
  offline_reason: 'Offline Reason',
  geofencing_deny: 'Geofencing Deny',
  geofencing_allow: 'Geofencing Allow',
  region: 'Region',
  video_url: 'Video Url',
  trailer_url: 'Trailer Url',
  subtitle_en_url: 'Subtitle En Url',
  svod: 'Svod',
  ad_timing: 'Ad Timing',
  ad_timing_status: 'Ad Timing Status',
  imdb_id: 'Imdb Id',
  year: 'Year',
  decade: 'Decade',
  restricted_content_reason: 'Restricted Content Reason',
  trashy: 'Trashy',
  good_bad: 'Good Bad',
  mm_notes: 'Mm Notes',
  duration_minutes: 'Duration Minutes',
  avod_watched: 'Avod Watched (In Minutes)',
  public_domain: 'Public Domain',
  country: 'Country',
  restricted_content_source: 'Restricted Content Source',
  custom_royality: 'Custom Royality',
  cast: 'Cast',
  tvod: 'Tvod',
  description_status: 'Description Status',
  pnm_exclusives: 'Pnm Exclusives',
  avod_watched_7: 'Avod Weekly Watched (In Minutes)',
  tvod_iap: 'Tvod Price',
  five_star_rating: 'Five Star Rating',
  tvod_enabled: 'Tvod Enabled',
  plot_keywords: 'Plot Keywords',
  schedule_priority: 'Schedule Priority',
  exclude_from_db: 'Exclude From Db',
  quality_video: 'Quality Video',
  title_name_only: 'Title Name Only',
  directors: 'Directors',
  writers: 'Writers',
  resolution: 'Resolution',
  series_id: 'Series Id',
  collection_id: 'Collection Id',
  poster_16x9_url: 'Poster 16x9 Url',
  poster_3x4_url: 'Poster 3x4 Url',
  trashy_rating: 'Trashy Rating',
  aspect_ratio: 'Aspect Ratio',
  mpaa_rating: 'Mpaa Rating',
  genre_status: 'Genre Status',
  featured_playlist: 'Featured Playlist',
  quality_max_resolution: 'Quality Max Resolution',
  mm_notes2trailer: 'Mm Notes2trailer',
  video_status: 'Video Status',
  video_status_reason: 'Video Status Reason',
  video_status_reason_details: 'Video Status Reason Details',
  trailer_status: 'Trailer Status',
  trailer_status_reason: 'Trailer Status Reason',
  always_published: 'Always Published',
};

export const CONTENT_SCHEDULE_TYPE = {
  GENERAL: 'GENERAL',
  HERO: 'HERO',
  ASSIGNMENT: 'ASSIGNMENT',
};

export const OVERVIEW_ALL_RULESETS_BTN_LABEL =
  'Restore Assignment/Scheduling To 20 May Old CMS';

export const EMAIL_SEND_ACTIONS = [
  { id: 'SIGNUP', title: 'Signup' },
  { id: 'RESET_PASSWORD_TV_APPS', title: 'Reset Password for TV Apps' },
  { id: 'RESET_PASSWORD_WEB', title: 'Reset Password for Web' },
  { id: 'SVOD_SUBSCRIPTION', title: 'New Svod Subscription' },
  { id: 'TVOD_SUBSCRIPTION', title: 'New Tvod Subscription' },
];

export const EMAIL_PLACEHOLDERS = [
  { value: 'app_name', label: 'App Name' },
  { value: 'full_name', label: 'Full Name' },
  { value: 'username', label: 'Username' },
  { value: 'email', label: 'Email' },
  { value: 'signup_date', label: 'Date of Signup' },
  { value: 'ip_address', label: 'IP Address' },
  { value: 'cc_last_four_digits', label: 'CC Last Four Digits' },
  { value: 'reset_password_code', label: 'Reset Password Code' },
  { value: 'reset_password_link', label: 'Reset Password Link' },
];

export const BLACKLIST_SOURCE_TYPE = [
  { label: 'IP Address', value: 'IP' },
  { label: 'CC Card Fingerprint', value: 'CC' },
  { label: 'Email Domain', value: 'EMAIL_DOMAIN' },
];

export const IMPORT_DATA_STATUS = {
  PENDING: { value: 'PENDING', label: 'Pending' },
  PROCESSING: { value: 'PROCESSING', label: 'Processing' },
  FINISHED: { value: 'FINISHED', label: 'Finished' },
  FAILED: { value: 'FAILED', label: 'Failed' },
};

export const SCHEDULE_EXPORT_STATUS = {
  PENDING: 0,
  0: 'Pending',
  ACTIVE: 1,
  1: 'Finished',
  FAILED: 2,
  2: 'Failed',
  IN_PROGRESS: 5,
  5: 'Processing',
};

export const CHANNEL_VIDEOS_COUNT_INFO_LIST = [
  {
    id: 'total_videos',
    title: 'Total Videos',
  },
  {
    id: 'total_movies',
    title: 'Total Movies',
  },
  {
    id: 'total_episodes',
    title: 'Total Episodes',
  },
  {
    id: 'always_scheduled_videos',
    title: 'Always Scheduled Videos',
  },
  {
    id: 'always_scheduled_movies',
    title: 'Always Scheduled Movies',
  },
  {
    id: 'always_scheduled_episodes',
    title: 'Always Scheduled Episodes',
  },
  {
    id: 'always_scheduled_movies_blocked',
    title: 'Always Scheduled Movies (Blocked)',
  },
  {
    id: 'always_scheduled_episodes_blocked',
    title: 'Always Scheduled Episodes (Blocked)',
  },
  {
    id: 'videos_available_for_scheduling',
    title: 'Videos Available For Scheduling',
  },
  {
    id: 'movies_available_for_scheduling',
    title: 'Movies Available For Scheduling',
  },
  {
    id: 'episodes_available_for_scheduling',
    title: 'Episodes Available For Scheduling',
  },
  {
    id: 'total_movies_scheduling_blocked',
    title: 'Total Movies Scheduling (Blocked)',
  },
  {
    id: 'total_episodes_scheduling_blocked',
    title: 'Total Episodes Scheduling (Blocked)',
  },
];

export const LANGUAGE_CODES = {
  en: { label: 'English', value: 'en' },
  es: { label: 'Spanish', value: 'es' },
  de: { label: 'German', value: 'de' },
  ab: { label: 'Abkhazian', value: 'ab' },
  aa: { label: 'Afar', value: 'aa' },
  af: { label: 'Afrikaans', value: 'af' },
  ak: { label: 'Akan', value: 'ak' },
  sq: { label: 'Albanian', value: 'sq' },
  am: { label: 'Amharic', value: 'am' },
  ar: { label: 'Arabic', value: 'ar' },
  an: { label: 'Aragonese', value: 'an' },
  hy: { label: 'Armenian', value: 'hy' },
  as: { label: 'Assamese', value: 'as' },
  av: { label: 'Avaric', value: 'av' },
  ae: { label: 'Avestan', value: 'ae' },
  ay: { label: 'Aymara', value: 'ay' },
  az: { label: 'Azerbaijani', value: 'az' },
  bm: { label: 'Bambara', value: 'bm' },
  ba: { label: 'Bashkir', value: 'ba' },
  eu: { label: 'Basque', value: 'eu' },
  be: { label: 'Belarusian', value: 'be' },
  bn: { label: 'Bengali', value: 'bn' },
  bh: { label: 'Bihari languages', value: 'bh' },
  bi: { label: 'Bislama', value: 'bi' },
  bs: { label: 'Bosnian', value: 'bs' },
  br: { label: 'Breton', value: 'br' },
  bg: { label: 'Bulgarian', value: 'bg' },
  my: { label: 'Burmese', value: 'my' },
  ca: { label: 'Catalan', value: 'ca' },
  km: { label: 'Central Khmer', value: 'km' },
  ch: { label: 'Chamorro', value: 'ch' },
  ce: { label: 'Chechen', value: 'ce' },
  ny: { label: 'Chichewa', value: 'ny' },
  zh: { label: 'Chinese', value: 'zh' },
  cu: { label: 'Church Slavonic', value: 'cu' },
  cv: { label: 'Chuvash', value: 'cv' },
  kw: { label: 'Cornish', value: 'kw' },
  co: { label: 'Corsican', value: 'co' },
  cr: { label: 'Cree', value: 'cr' },
  hr: { label: 'Croatian', value: 'hr' },
  cs: { label: 'Czech', value: 'cs' },
  da: { label: 'Danish', value: 'da' },
  dv: { label: 'Divehi', value: 'dv' },
  nl: { label: 'Dutch, Flemish', value: 'nl' },
  dz: { label: 'Dzongkha', value: 'dz' },
  eo: { label: 'Esperanto', value: 'eo' },
  et: { label: 'Estonian', value: 'et' },
  ee: { label: 'Ewe', value: 'ee' },
  fo: { label: 'Faroese', value: 'fo' },
  fj: { label: 'Fijian', value: 'fj' },
  fi: { label: 'Finnish', value: 'fi' },
  fr: { label: 'French', value: 'fr' },
  ff: { label: 'Fulah', value: 'ff' },
  gd: { label: 'Gaelic', value: 'gd' },
  gl: { label: 'Galician', value: 'gl' },
  lg: { label: 'Ganda', value: 'lg' },
  ka: { label: 'Georgian', value: 'ka' },
  ki: { label: 'Gikuyu, Kikuyu', value: 'ki' },
  el: { label: 'Greek (Modern)', value: 'el' },
  kl: { label: 'Greenlandic', value: 'kl' },
  gn: { label: 'Guarani', value: 'gn' },
  gu: { label: 'Gujarati', value: 'gu' },
  ht: { label: 'Haitian', value: 'ht' },
  ha: { label: 'Hausa', value: 'ha' },
  he: { label: 'Hebrew', value: 'he' },
  hz: { label: 'Herero', value: 'hz' },
  hi: { label: 'Hindi', value: 'hi' },
  ho: { label: 'Hiri Motu', value: 'ho' },
  hu: { label: 'Hungarian', value: 'hu' },
  is: { label: 'Icelandic', value: 'is' },
  io: { label: 'Ido', value: 'io' },
  ig: { label: 'Igbo', value: 'ig' },
  id: { label: 'Indonesian', value: 'id' },
  ia: {
    label: 'Interlingua (International Auxiliary Language Association)',
    value: 'ia',
  },
  ie: { label: 'Interlingue', value: 'ie' },
  iu: { label: 'Inuktitut', value: 'iu' },
  ik: { label: 'Inupiaq', value: 'ik' },
  ga: { label: 'Irish', value: 'ga' },
  it: { label: 'Italian', value: 'it' },
  ja: { label: 'Japanese', value: 'ja' },
  jv: { label: 'Javanese', value: 'jv' },
  kn: { label: 'Kannada', value: 'kn' },
  kr: { label: 'Kanuri', value: 'kr' },
  ks: { label: 'Kashmiri', value: 'ks' },
  kk: { label: 'Kazakh', value: 'kk' },
  rw: { label: 'Kinyarwanda', value: 'rw' },
  kv: { label: 'Komi', value: 'kv' },
  kg: { label: 'Kongo', value: 'kg' },
  ko: { label: 'Korean', value: 'ko' },
  kj: { label: 'Kwanyama', value: 'kj' },
  ku: { label: 'Kurdish', value: 'ku' },
  ky: { label: 'Kyrgyz', value: 'ky' },
  lo: { label: 'Lao', value: 'lo' },
  la: { label: 'Latin', value: 'la' },
  lv: { label: 'Latvian', value: 'lv' },
  lb: { label: 'Letzeburgesch', value: 'lb' },
  li: { label: 'Limburgish', value: 'li' },
  ln: { label: 'Lingala', value: 'ln' },
  lt: { label: 'Lithuanian', value: 'lt' },
  lu: { label: 'Luba-Katanga', value: 'lu' },
  mk: { label: 'Macedonian', value: 'mk' },
  mg: { label: 'Malagasy', value: 'mg' },
  ms: { label: 'Malay', value: 'ms' },
  ml: { label: 'Malayalam', value: 'ml' },
  mt: { label: 'Maltese', value: 'mt' },
  gv: { label: 'Manx', value: 'gv' },
  mi: { label: 'Maori', value: 'mi' },
  mr: { label: 'Marathi', value: 'mr' },
  mh: { label: 'Marshallese', value: 'mh' },
  ro: { label: 'Moldovan', value: 'ro' },
  mn: { label: 'Mongolian', value: 'mn' },
  na: { label: 'Nauru', value: 'na' },
  nv: { label: 'Navajo', value: 'nv' },
  nd: { label: 'Northern Ndebele', value: 'nd' },
  ng: { label: 'Ndonga', value: 'ng' },
  ne: { label: 'Nepali', value: 'ne' },
  se: { label: 'Northern Sami', value: 'se' },
  no: { label: 'Norwegian', value: 'no' },
  nb: { label: 'Norwegian Bokmål', value: 'nb' },
  nn: { label: 'Norwegian Nynorsk', value: 'nn' },
  ii: { label: 'Nuosu', value: 'ii' },
  oc: { label: 'Occitan (post 1500)', value: 'oc' },
  oj: { label: 'Ojibwa', value: 'oj' },
  or: { label: 'Oriya', value: 'or' },
  om: { label: 'Oromo', value: 'om' },
  os: { label: 'Ossetian', value: 'os' },
  pi: { label: 'Pali', value: 'pi' },
  pa: { label: 'Panjabi', value: 'pa' },
  ps: { label: 'Pashto', value: 'ps' },
  fa: { label: 'Persian', value: 'fa' },
  pl: { label: 'Polish', value: 'pl' },
  pt: { label: 'Portuguese', value: 'pt' },
  qu: { label: 'Quechua', value: 'qu' },
  rm: { label: 'Romansh', value: 'rm' },
  rn: { label: 'Rundi', value: 'rn' },
  ru: { label: 'Russian', value: 'ru' },
  sm: { label: 'Samoan', value: 'sm' },
  sg: { label: 'Sango', value: 'sg' },
  sa: { label: 'Sanskrit', value: 'sa' },
  sc: { label: 'Sardinian', value: 'sc' },
  sr: { label: 'Serbian', value: 'sr' },
  sn: { label: 'Shona', value: 'sn' },
  sd: { label: 'Sindhi', value: 'sd' },
  si: { label: 'Sinhala', value: 'si' },
  sk: { label: 'Slovak', value: 'sk' },
  sl: { label: 'Slovenian', value: 'sl' },
  so: { label: 'Somali', value: 'so' },
  st: { label: 'Sotho', value: 'st' },
  nr: { label: 'South Ndebele', value: 'nr' },
  su: { label: 'Sundanese', value: 'su' },
  sw: { label: 'Swahili', value: 'sw' },
  ss: { label: 'Swati', value: 'ss' },
  sv: { label: 'Swedish', value: 'sv' },
  tl: { label: 'Tagalog', value: 'tl' },
  ty: { label: 'Tahitian', value: 'ty' },
  tg: { label: 'Tajik', value: 'tg' },
  ta: { label: 'Tamil', value: 'ta' },
  tt: { label: 'Tatar', value: 'tt' },
  te: { label: 'Telugu', value: 'te' },
  th: { label: 'Thai', value: 'th' },
  bo: { label: 'Tibetan', value: 'bo' },
  ti: { label: 'Tigrinya', value: 'ti' },
  to: { label: 'Tonga (Tonga Islands)', value: 'to' },
  ts: { label: 'Tsonga', value: 'ts' },
  tn: { label: 'Tswana', value: 'tn' },
  tr: { label: 'Turkish', value: 'tr' },
  tk: { label: 'Turkmen', value: 'tk' },
  tw: { label: 'Twi', value: 'tw' },
  ug: { label: 'Uighur', value: 'ug' },
  uk: { label: 'Ukrainian', value: 'uk' },
  ur: { label: 'Urdu', value: 'ur' },
  uz: { label: 'Uzbek', value: 'uz' },
  ve: { label: 'Venda', value: 've' },
  vi: { label: 'Vietnamese', value: 'vi' },
  vo: { label: 'Volap_k', value: 'vo' },
  wa: { label: 'Walloon', value: 'wa' },
  cy: { label: 'Welsh', value: 'cy' },
  fy: { label: 'Western Frisian', value: 'fy' },
  wo: { label: 'Wolof', value: 'wo' },
  xh: { label: 'Xhosa', value: 'xh' },
  yi: { label: 'Yiddish', value: 'yi' },
  yo: { label: 'Yoruba', value: 'yo' },
  za: { label: 'Zhuang', value: 'za' },
  zu: { label: 'Zulu', value: 'zu' },
};

export const CDN77_STATUS = {
  NEW: 'new',
  PENDING: 'pending',
  PREPROCESSING: 'preprocessing',
  RUNNING: 'running',
  POSTPROCESSING: 'postprocessing',
  COMPLETE: 'complete',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  ERROR: 'error',
};

export const CONNECTED_SOURCE_FOLDER_SYNC_STATUS = {
  SYNCED_FROM_FTP: { value: 'SYNCED_FROM_FTP', label: 'Discovered Title' },
  VALIDATING_FTP_DATA: {
    value: 'VALIDATING_FTP_DATA',
    label: 'Validating Title Assets',
  },
  SYNCING_WITH_S3: { value: 'SYNCING_WITH_S3', label: 'Syncing to S3' },
  NEW: { value: 'NEW', label: 'New (Not Queued)' },
  QUEUED: { value: 'QUEUED', label: 'Queued for Processing' },
  VALIDATING: { value: 'VALIDATING', label: 'Validating Assets' },
  PROCESSING: { value: 'PROCESSING', label: 'CMS Pre-Processing' },
  SYNCING_WITH_CMS: {
    value: 'SYNCING_WITH_CMS',
    label: 'Generating CMS Records',
  },
  ASSET_UPLOAD: { value: 'ASSET_UPLOAD', label: 'Sending to Encoder' },
  ASSET_UPLOAD_INPROGRESS: {
    value: 'ASSET_UPLOAD_INPROGRESS',
    label: 'Uploading to Encoder',
  },
  ENCODING: { value: 'ENCODING', label: 'Encoding' },
  COMPLETED: { value: 'COMPLETED', label: 'Complete' },
  ERROR: { value: 'ERROR', label: 'Failed' },
  MISSING_CSV: { value: 'MISSING_CSV', label: 'Missing CSV' },
  MISSING_ASSETS: { value: 'MISSING_ASSETS', label: 'Missing Assets' },
};

export const CONNECTED_SOURCE_TYPE = {
  S3: { value: 'S3', label: 'S3' },
  CDN77_S3: { value: 'CDN77_S3', label: 'CDN77 S3' },
  FTP: { value: 'FTP', label: 'FTP' },
};

export const BANK_PREFERENCE = {
  bank1: 'Bank 1',
  bank2: 'Bank 2',
};

export const CDN_BASE_URL = 'https://1680547282.rsc.cdn77.org/';

export const VIDEO_COLOR = {
  COLOR: 'Color',
  BLACKANDWHITE: 'Black and White',
  COLORIZED: 'Colorized',
};

export const CONTENT_SOURCE_TYPE = {
  MOVIE: 'Movie',
  SERIES: 'Series',
};
